import React from 'react';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';

import { Creators as TasksActions } from '../ducks/task';

import { TaskAPi } from '../../services/api';

import { WarningToast } from '../../components/molecules/Toast';

export function* putReprocessarTask(action) {
  const { taskId } = action.payload;

  try {
    const response = yield call(TaskAPi.put, `/reprocess/${taskId}`);
    const isSuccess = response.status === 200 || false;
    yield put(
      TasksActions.putReprocessarTaskResponse(response.data, isSuccess)
    );
  } catch (error) {
    console.log(error);
    /* yield put(TasksActions.getListaArquivosError(error)); */
  }
}
export function* getUltimoErroTask(action) {
  const { taskId } = action.payload;

  try {
    const response = yield call(TaskAPi.get, `/details-last-error/${taskId}`);
    const isSuccess = response.status === 200 || false;
    yield put(TasksActions.getUltimoErroTaskResponse(response.data, isSuccess));
  } catch (error) {
    console.log(error);
    /* yield put(TasksActions.getListaArquivosError(error)); */
  }
}

/* {
  toast.success(
    <WarningToast size="30">
      {error?.response?.data?.errors?.Messages[0] || error?.message}
    </WarningToast>
  );
} */
